import { createAction, props } from '@ngrx/store';
import {
  PettyCashBalance,
  PettyCashUpdateRequest,
} from '../../../../features/gse/petty-cash/models/petty-cash.model';
import { PettyCashAccountResponse } from '../../../../api/gse/models/petty-cash-account-response';

export const loadPettyCashBalance = createAction('[PettyCash] Load Balance');

export const loadPettyCashBalanceSuccess = createAction(
  '[PettyCash] Load Balance Success',
  props<{ response: PettyCashAccountResponse }>()
);

export const loadPettyCashBalanceFailure = createAction(
  '[PettyCash] Load Balance Failure',
  props<{ error: string }>()
);

export const updatePettyCashBalance = createAction(
  '[PettyCash] Update Balance',
  props<{ body: PettyCashUpdateRequest }>()
);

export const updatePettyCashBalanceSuccess = createAction(
  '[PettyCash] Update Balance Success',
  props<{ response: PettyCashAccountResponse }>()
);

export const updatePettyCashBalanceFailure = createAction(
  '[PettyCash] Update Balance Failure',
  props<{ error: string }>()
);
